import React from "react";

import { view } from "modules/Community";

import { routes } from "../../constants";

const CommunityThemePage = () => <view.Theme congratulationUrl={routes.onboarding.congratulation.getPath()} />;

export default CommunityThemePage;
